import { Typography } from '@material-ui/core';
import { ColorDynamic, Inline, Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { SuperPayBankAccountDTO } from 'shared/modules/superpay/SuperPayDTO';
import styled from 'styled-components';
import routingAccountIllustration from '../../assets/routing_account.png';
import { LightBulb } from '../../assets/LightBulbIcon';
import { ShieldIcon } from '../../assets/SheildIcon';
import { BankAccountFormFields } from '../bank-account/BankAccountForm';
import { PaymentsInMotionAlert } from './PaymentsInMotionAlert';

const HelpCard = styled(Box)`
  background-color: ${ColorDynamic.Silver200};
  border-radius: 8px;
  display: flex;
  padding: 8px;
  align-items: flex-start;
  gap: 8px;
`;

interface Props {
  bankAccount?: SuperPayBankAccountDTO;
}

export function ChangeBankAccountForm({ bankAccount }: Props) {
  return (
    <Stack space="medium">
      <Stack space="small">
        {bankAccount ? (
          <PaymentsInMotionAlert bankAccount={bankAccount} />
        ) : (
          <Typography color="textSecondary">
            To enable payments, we are legally required to collect information
            below. This information is not stored by Super Dispatch and only
            used to verify the business.
          </Typography>
        )}

        <Inline space="xxsmall" verticalAlign="center" noWrap={true}>
          <ShieldIcon fontSize="small" />
          <Typography color="textSecondary">
            Your personal data is encrypted and private.
          </Typography>
        </Inline>

        <BankAccountFormFields />
      </Stack>

      <HelpCard padding="small">
        <LightBulb />
        <Stack space="xsmall">
          <Typography variant="h5">Where to find bank details?</Typography>
          <Typography color="textSecondary">
            These numbers can be found at the bottom of a check or by contacting
            your bank.
          </Typography>
          <img
            src={routingAccountIllustration}
            width="292px"
            alt="routing account illustration"
          />
        </Stack>
      </HelpCard>
    </Stack>
  );
}
